import {
  useProductList,
  useTagList,
} from "../../../pages/help/use-fetch-cosmicjs-state";

export const useSearchResultsController = () => {
  const tagListResult = useTagList();

  const productListResult = useProductList();

  return {
    tagListResult,
    productListResult,
  };
};
